import * as React from 'react';


type Props = {
  className?: string;
  fill?: string;
  sizePx: number;
};


/**
 * SendIcon: a component that renders a custom paper airplane-styled icon, typically used to denote send functions in
 * the app.
 */
const SendIcon: React.FC<Props> = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height={props.sizePx}
    viewBox='0 0 24 24'
    width={props.sizePx}
    className={props.className}
  >
    <path d='M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' fill={props.fill} />
  </svg>
);

export default SendIcon;
